import React from "react";
import { NewVideosForm } from "../../components";

const NewVideos = () => {
  return <NewVideosForm />;
};

export default NewVideos;
